export const GRID_VIEW = 'grid';
export const SUMMARY_VIEW = 'summary';
export const PAYROLL_VIEW = 'payroll';

export type TimesheetView = typeof GRID_VIEW | typeof SUMMARY_VIEW | typeof PAYROLL_VIEW;
